import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Tile } from 'ol/layer';
import { TileWMS } from 'ol/source';
import { MapComponent } from '../map.component';

@Component({
    selector: 'app-benomad-layer',
    template: ''
})
export class BenomadLayerComponent implements OnInit, OnChanges, OnDestroy {

    @Input() visible: boolean;
    @Input() appUrl: string;
    @Input() appCode: string;
    @Input() appId: string;

    benomadLayer: Tile;

    constructor(
        private _map: MapComponent
    ) { }

    ngOnInit(): void {
        this.benomadLayer = this.initializeBenomad();
        this._map.instance.addLayer(this.benomadLayer);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.benomadLayer) {
            return;
        }
        if ('visible' in changes) {
            this.benomadLayer.setVisible(this.visible);
        }
    }

    ngOnDestroy(): void {
        this._map.instance.removeLayer(this.benomadLayer);
    }

    initializeBenomad(): Tile {
        return new Tile({
            visible: this.visible,
            source: new TileWMS({
                url: `${this.appUrl}?appid=${this.appId}&appcode=${this.appCode}`,
                params: {
                    //'geoserver': 'osm180514',
                    //'STYLES': 'bd',
                    'LAYERS': 'default',
                    'TILED': true,
                    'TRANSPARENT': false
                }
            })
        });
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/layers/benomad-layer.component.ts